import {useFundamentalsLanguage} from '@hconnect/common/hooks'
import {CommentProps, ControlledCommentBoxComment} from '@hm/fundamental'

type Props<TComment extends CommentProps<string | number> = CommentProps<string | number>> = {
  comments: TComment[]
  onEdit: (comment: TComment, newContent: string) => Promise<void>
  onDelete: (comment: TComment) => Promise<void>
}

export const CommentBoxComments = <TComment extends CommentProps<string | number>>({
  comments,
  onEdit,
  onDelete
}: Props<TComment>) => {
  const language = useFundamentalsLanguage()

  return (
    <div className="flex flex-col gap-y-6 mt-12px pb-10" data-test-id="comments-list">
      {comments.map((comment) => (
        <ControlledCommentBoxComment
          key={comment.id}
          language={language}
          comment={comment}
          onDelete={() => onDelete(comment)}
          onEdit={(newContent) => onEdit(comment, newContent)}
        />
      ))}
    </div>
  )
}
